// src/pages/NavDetails/PriceDetails.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import TermsAndPolicyFooter from "../../components/common/PrivacyPolicy/CompanyTermsAndPolicy/TermsAndPolicyFooter";

const features = [
  "3,000 Free Assessment Attempts",
  "Easy 1-Step Registration",
  "Unlimited Assessment Creations",
  "AI-Powered Question Generation",
  "Real-Time Results & Leaderboards",
];

const PriceDetails = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-white relative overflow-hidden">

      
      {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full"></div> */}

  
      <div className="flex-1 flex flex-col items-center px-4 py-20">

        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-14 
        bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
          Our Pricing
        </h1>

        
        <section className="w-full max-w-5xl rounded-3xl overflow-hidden 
        bg-white/60 backdrop-blur-xl border border-white/40 
        shadow-[0_20px_60px_rgba(0,0,0,0.1)]">

          <div className="grid md:grid-cols-2">

           
            <div className="p-10 md:p-14 flex flex-col justify-center gap-8 
            border-b md:border-b-0 md:border-r border-white/30">

              <h2 className="text-2xl md:text-3xl font-bold leading-snug text-gray-800">
                Register now and get a starter kit worth{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-l from-indigo-950 to-indigo-800">
                  3000 assessments!
                </span>
              </h2>

              <button
                type="button"
                onClick={() => navigate("/login_register")}
                className="self-start text-lg font-semibold px-8 py-3 rounded-xl 
                text-white bg-gradient-to-l from-indigo-950 to-indigo-800 
                shadow-lg hover:scale-105 hover:shadow-xl 
                transition-all duration-300"
              >
                Register Now
              </button>

            </div>

         
            <div className="p-10 md:p-14 flex flex-col justify-center">

              <ul className="space-y-5">
                {features.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 text-gray-700 text-lg"
                  >
                    <span className="text-green-500 text-xl">✔</span>
                    {item}
                  </li>
                ))}
              </ul>

            </div>

          </div>
        </section>

      </div>


      <TermsAndPolicyFooter />

    </div>
  );
};

export default PriceDetails;